// DO NOT EDIT EXISTING EVENT/FEATURE NAMES AS THEY ARE ALREADY GETTING TRACKED IN MIXPANEL

export enum MIXPANEL_APP_FEATURES {
	LANDING_PAGE = 'Landing Page',
	LOGIN_PAGE = 'Login',
	USER_ONBOARDING = 'Normal User Onboarding',
	USER_ONBOARDING_VIA_MODAL = 'User Onboarding Via Modal',
	WORKSPACE = 'Workspace',
	FORM = 'Form',
	FORM_RESPONSES = 'Form Responses',
	FORM_PLAYGROUND = 'Form Playground',
	MESSAGES = 'Messages',
	DASHBOARD = 'Dashboard',
	SETTINGS = 'Settings',
	ALL_CANDIDATES = 'All Candidates',
	IMPORT_FORM = 'Import Form',
	IMPORT_SUBMISSIONS = 'Import Submissions',
	PRICING = 'Pricing',
	NOT_FOUND = 'Not Found',
	AI_ASSISTANT = 'AI Assistant',
	AI_AGENT = 'AI Agent',
	AI_ONBOARDING = 'AI Onboarding',
	APP_LEVEL = 'App level',
	ANALYTICS = 'Analytics',
	REFERRALS = 'Referrals',
	COMPARE_PAGE = 'Compare Page',
	AI_SCREENING_PAGE = 'AI Screening Page',
	MCP_PAGE = 'MCP Page',
	AI_ATS_PAGE = 'AI ATS Page',
	SWITCH_PAGE = 'Switch Page',
	ASSIGNMENTS = 'Assignments',
	MCP_CONSENT = 'MCP Consent',
	OFFER_LETTERS = 'Offer Letters',
}

export const mixpanelEvents = {
	// LANDING PAGE
	VIEWED_LANDING_PAGE: 'Landing Page Opened',
	CLICKED_LANDING_PAGE_SIGN_IN: 'Landing Page Sign In Clicked',
	CLICKED_LANDING_PAGE_GET_EARLY_ACCESS: 'Landing Page Get Early Access Clicked',
	CLICKED_WATCH_VIDEO: 'Watch Video Clicked',
	CLICKED_LANDING_PAGE_PRICING: 'Landing Page Pricing Button Clicked',
	CLICKED_LANDING_PAGE_PRICING_START_BUTTON: 'Landing page pricing start button clicked',
	// landing-page "Get Started" CTA; every other marketing page uses CLICKED_GET_STARTED with a `page` prop
	CLICKED_LANDING_PAGE_GET_STARTED: 'Landing Page Get Started Clicked',
	// "Get Started" CTA on non-landing marketing pages (free-ats, ai-screening, compare); discriminated by `page`
	CLICKED_GET_STARTED: 'Get Started Clicked',

	// COMPARE PAGE
	VIEWED_COMPARE_PAGE: 'Compare Page Opened',

	// AI SCREENING PAGE
	VIEWED_AI_SCREENING_PAGE: 'AI Screening Page Opened',

	// MCP PAGE
	VIEWED_MCP_PAGE: 'MCP Page Opened',

	// AI ATS PAGE
	VIEWED_AI_ATS_PAGE: 'AI ATS Page Opened',

	// SWITCH PAGE
	VIEWED_SWITCH_PAGE: 'Switch Page Opened',

	// LOGIN / AUTHENTICATION
	VIEWED_LOGIN_PAGE: 'Login Page Opened',
	VIEWED_LOGIN_PAGE_CODE_MODAL: 'Login Page Code Modal Shown',
	CLICKED_LOGIN_PAGE_GOOGLE: 'Login Page Google Clicked',
	CLICKED_LOGIN_BUTTON: 'Login Button Clicked',
	ACTION_LOGGED_OUT: 'User Logged Out',
	ACTION_LOGIN_OTP_SENT: 'User Login OTP Sent',
	COMPLETED_LOGIN: 'Login Completed',
	COMPLETED_GOOGLE_LOGIN: 'Google Login Completed',
	LOGIN_REDIRECTED: 'Login Redirected',

	// ONBOARDING
	VIEWED_ONBOARDING_NAME_SCREEN: 'Onboarding Name Screen Showed',
	VIEWED_CREATE_WORKSPACE_SCREEN: 'Create Workspace Screen Showed',
	VIEWED_NEW_ONBOARDING_LOGIN_SCREEN: 'Viewed - New Onboarding Login Screen',
	VIEWED_NEW_ONBOARDING_NAME_SCREEN: 'Viewed - New Onboarding Name Screen',
	VIEWED_NEW_ONBOARDING_CREATE_WORKSPACE_SCREEN: 'Viewed - New Onboarding Create Workspace Screen',
	CLICKED_ONBOARDING_SIGNIN_BUTTON: 'Onboarding Sign In Button Clicked',
	CLICKED_ONBOARDING_GOOGLE_SIGNIN_BUTTON: 'Onboarding Google Sign In Button Clicked',
	COMPLETED_ONBOARDING: 'Completed - Onboarding',
	COMPLETED_CREATE_WORKSPACE: 'Create Workspace Success',
	JOIN_WORKSPACE_SCREEN_SHOWED: 'Join Workspace Screen Showed',
	JOIN_WORKSPACE_CLICKED: 'Join Workspace Clicked',
	CREATE_NEW_WORKSPACE_INSTEAD_CLICKED: 'Create New Workspace Instead Clicked',
	JOIN_WORKSPACE_SUCCESS: 'Join Workspace Success',

	// FORM FILLING
	VIEWED_FORM_CODE_MODAL: 'Form Code Modal Shown',
	VIEWED_FORM_SUBMIT_ERROR: 'Form Submit Error Shown',
	VIEWED_FORM_OTP_ERROR: 'Form OTP Error Shown',
	VIEWED_FORM_FILE_UPLOAD_ERROR: 'Form File Upload Error Shown',
	VIEWED_FORM_NOT_FOUND: 'Form Not Found',
	VIEWED_FORM_ALREADY_FILLED: 'Form Already Filled',
	VIEWED_FORM_CLOSED: 'Form Closed',
	CLICKED_FORM_SUBMIT: 'Form Submit Clicked',
	COMPLETED_FORM_SUBMITTED: 'Form Submitted',

	// FORM EDITING
	VIEWED_FORM_EDIT_PAGE: 'Form Edit Page Opened',
	VIEWED_FORM_PLAYGROUND_PAGE: 'Form Playground Page Opened',
	VIEWED_FORM_EDIT_SETTINGS_MODAL: 'Form Edit Settings Modal Shown',
	CLICKED_CREATE_FORM: 'Create Form Clicked',
	CLICKED_VIEW_FORM: 'View Form Clicked',
	CLICKED_COPY_FORM_LINK: 'Copy Form Link Clicked',
	CLICKED_DUPLICATE_FORM: 'Duplicate Form Clicked',
	CLICKED_FORM_PUBLISHED_LINK_COPY: 'Form Published Link Copy Clicked',
	CLICKED_FORM_EDIT_PREVIEW: 'Form Edit Preview Clicked',
	CLICKED_FORM_EDIT_PUBLISH: 'Form Edit Publish Clicked',
	ACTION_FORM_PUBLISHED: 'Form Published',
	ACTION_FORM_EDIT_CLOSING_DATE_UPDATED: 'Form Edit Closing Date Updated',
	ACTION_FORM_EDIT_QUESTION_ADDED: 'Form Edit Question Added',
	ACTION_FORM_EDIT_QUESTION_DUPLICATED: 'Form Edit Question Duplicated',
	ACTION_FORM_EDIT_QUESTION_DELETED: 'Form Edit Question Deleted',
	ACTION_FORM_EDIT_QUESTION_TYPE_UPDATED: 'Form Edit Question Type Updated',
	ACTION_FORM_EDIT_WIDGET_TOGGLED: 'Form Edit Widget Toggled',

	// FORM SETTINGS
	ACTION_FORM_SETTINGS_UPDATED: 'Form Settings Updated',
	ACTION_FORM_SETTINGS_ACCEPTING_RESPONSES_TOGGLED: 'Form Settings Accepting Responses Toggled',
	ACTION_FORM_SETTINGS_VERIFY_EMAIL_TOGGLED: 'Form Settings Verify Email Toggled',
	ACTION_FORM_SETTINGS_SHOW_ON_PUBLIC_PAGE_TOGGLED: 'Form Settings Show On Public Page Toggled',
	ACTION_FORM_DEADLINE_CHANGED: 'Form Deadline Changed',
	ACTION_SETTINGS_SLACK_CONNECTED: 'Settings Slack Connected',
	ACTION_SETTINGS_SLACK_DISCONNECTED: 'Settings Slack Disconnected',
	ACTION_SETTINGS_LINKEDIN_CONNECTED: 'Settings LinkedIn Connected',
	ACTION_SETTINGS_LINKEDIN_DISCONNECTED: 'Settings LinkedIn Disconnected',
	/** Waitlist signal from the MCP section — the feature itself is not built yet. */
	ACTION_SETTINGS_MCP_INTEREST: 'Settings MCP Interest Registered',
	/** Connect clicked on a row of the AI assistants card; `connector` says which. */
	CLICKED_SETTINGS_AI_CONNECTOR_CONNECT: 'Settings AI Connector Connect Clicked',

	// FORM RESPONSES / DASHBOARD
	ACTION_FORM_TABLE_FILTERS_CLEARED: 'Form Table Filters Cleared',
	VIEWED_DASHBOARD_PAGE: 'Dashboard Page Opened',
	VIEWED_FORM_DASHBOARD_PAGE: 'Form Dashboard Page Opened',
	VIEWED_FORM_DASHBOARD_NO_ACCESS: 'Form Dashboard No Access Shown',
	VIEWED_FORM_DASHBOARD_AI_PANEL: 'Form Dashboard AI Panel Opened',
	VIEWED_APPLICATIONS_PAGE: 'Applications Page Opened',
	CLICKED_DASHBOARD_NEW_FORM: 'Dashboard New Form Clicked',
	CLICKED_FORM_DASHBOARD_EXPORT_CSV: 'Form Dashboard Export CSV Clicked',
	CLICKED_FORM_DASHBOARD_ANALYTICS: 'Form Dashboard Analytics Clicked',
	ACTION_FORM_DASHBOARD_TAB_SWITCHED: 'Form Dashboard Tab Switched',
	ACTION_FORM_DASHBOARD_ACCEPTING_TOGGLE_CHANGED: 'Form Dashboard Accepting Toggle Changed',
	ACTION_FORM_TABLE_SORT: 'Form Table Sort Done',
	ACTION_FORM_TABLE_SEARCH: 'Form Table Search Done',
	ACTION_FORM_TABLE_FILTER_APPLIED: 'Form Table Filter Applied',
	ACTION_FORM_TABLE_CLEAR_ALL_FILTERS: 'Form Table Clear All Filters',

	// APPLICATION MANAGEMENT
	ACTION_LABEL_ADDED: 'Label Added',
	ACTION_LABEL_REMOVED: 'Label Removed',
	ACTION_NOTE_ADDED: 'Note Added',
	ACTION_NOTE_DELETED: 'Note Deleted',
	ACTION_FEEDBACK_ADDED: 'Feedback Added',
	ACTION_FEEDBACK_DELETED: 'Feedback Deleted',
	ACTION_APPLICATION_STAGE_CHANGED: 'Application Stage Changed',

	// SCHEDULING
	CLICKED_SCHEDULE_INTERVIEW: 'Schedule Interview Clicked',
	CLICKED_GCAL_CONNECT: 'GCal Connect Clicked',
	GCAL_CONNECTED: 'GCal Connected',
	ACTION_INTERVIEW_SCHEDULED: 'Interview Scheduled',
	ACTION_INTERVIEW_DELETED: 'Interview Deleted',
	ACTION_AVAILABILITY_UPDATED: 'Availability Updated',
	ACTION_GCAL_DWD_CONNECTED: 'GCal DWD Connected',
	ACTION_GCAL_DWD_DISCONNECTED: 'GCal DWD Disconnected',
	CLICKED_SCHEDULING_MODE_TOGGLE: 'Scheduling Mode Toggle Clicked',
	ACTION_SCHEDULING_LINK_CREATED: 'Scheduling Link Created',
	ACTION_SCHEDULING_LINK_CANCELLED: 'Scheduling Link Cancelled',
	ACTION_SCHEDULING_LINK_RESENT: 'Scheduling Link Resent',
	ACTION_NUDGE_INTERVIEWER_CALENDAR: 'Interviewer Calendar Nudge Sent',
	PUBLIC_BOOKING_PAGE_VIEWED: 'Public Booking Page Viewed',
	PUBLIC_BOOKING_SLOT_SELECTED: 'Public Booking Slot Selected',
	PUBLIC_BOOKING_CONFIRMED: 'Public Booking Confirmed',
	PUBLIC_BOOKING_TIMEZONE_CHANGED: 'Public Booking Timezone Changed',
	PUBLIC_BOOKING_CANCELLED_VIEW: 'Public Booking Cancelled View',

	// ALL CANDIDATES
	VIEWED_ALL_CANDIDATES_PAGE: 'All Candidates Page Opened',
	CLICKED_ALL_CANDIDATES_ROW: 'All Candidates Row Clicked',

	// FOCUS MODE / FAST MODE
	VIEWED_FOCUS_MODE: 'Focus Mode Opened',
	VIEWED_FAST_MODE: 'Fast Mode Opened',
	VIEWED_FAST_MODE_REPLY_NUDGE: 'Fast Mode Reply Nudge Shown',
	CLICKED_FAST_MODE_REPLY_NUDGE_SEND: 'Fast Mode Reply Nudge Send Clicked',
	CLICKED_FAST_MODE_REPLY_NUDGE_CANCEL: 'Fast Mode Reply Nudge Cancel Clicked',
	ACTION_FOCUS_MODE_ACTION_TAKEN: 'Focus Mode Action Taken',
	ACTION_FAST_MODE_ACTION_TAKEN: 'Fast Mode Action Taken',
	ACTION_FAST_MODE_SETTING_CHANGED: 'Fast Mode Setting Changed',
	ACTION_FOCUS_MODE_STAGE_UPDATE_FAILED: 'Focus Mode Stage Update Failed',
	ACTION_FOCUS_MODE_MESSAGE_SEND_FAILED: 'Focus Mode Message Send Failed',
	ACTION_FOCUS_MODE_CANDIDATE_DELETED: 'Focus Mode Candidate Deleted',
	ACTION_FOCUS_MODE_INVALID_SUBMISSION: 'Focus Mode Invalid Submission Opened',

	// AI Review
	VIEWED_AI_ASSISTANT_PANEL: 'AI Assistant Panel Opened',
	VIEWED_AI_NUDGE: 'AI Nudge Shown',
	CLICKED_AI_QUERY_CONTINUE: 'AI Query Continue Clicked',
	CLICKED_AI_RECOMMENDATION: 'AI Recommendation Clicked',
	CLICKED_AI_NUDGE_DISMISS: 'AI Nudge Dismissed',
	CLICKED_AI_QUERY_REFINE_SUBMIT: 'AI Query Refine Submit Clicked',
	ACTION_AI_QUERY_STARTED: 'AI Query Started',
	ACTION_AI_QUERY_START_FAILED: 'AI Query Start Failed',
	ACTION_AI_SCANNING_STARTED: 'AI Scanning Started',
	ACTION_AI_QUERY_SCANNING_API_ERROR: 'AI Query Scanning Api Error',
	ACTION_AI_QUERY_STOPPED: 'AI Query Stopped',
	ACTION_AI_QUERY_RATE_LIMITED: 'AI Query Rate Limited', // when credits are exhausted (429 error)
	ACTION_AI_QUERY_COUNT_INCREASED: 'AI Query Count Increased',
	COMPLETED_AI_QUERY: 'AI Query Completed',
	VIEWED_AI_LINKEDIN_DEEP_REVIEW_PROMPT: 'AI LinkedIn Deep Review Prompt Shown',
	ACTION_AI_LINKEDIN_DEEP_REVIEW_ACCEPTED: 'AI LinkedIn Deep Review Accepted',
	ACTION_AI_LINKEDIN_DEEP_REVIEW_DECLINED: 'AI LinkedIn Deep Review Declined',
	ACTION_AI_QUERY_DELETED: 'AI Query Deleted',
	ACTION_AI_QUERY_CRITERIA_DELETED: 'AI Query Criteria Deleted',
	AI_REVIEW_CRITERIA_ADDED: 'AI Review Criteria Added',
	AI_REVIEW_SHORTLIST_CRITERIA_SAVED: 'AI Review Shortlist Criteria Saved',
	AI_REVIEW_SHORTLIST_CRITERIA_EDITED: 'AI Review Shortlist Criteria Edited',
	AI_REVIEW_TASK_RESUMED: 'AI Review Task Resumed',
	AI_REVIEW_AUTO_REVIEW_TOGGLED: 'AI Review Auto Review Toggled',
	AI_REVIEW_PENDING_CRITERIA_DELETED: 'AI Review Pending Criteria Deleted',
	AI_REVIEW_UPGRADE_CLICKED: 'AI Review Upgrade Clicked',
	CLICKED_AI_REVIEW_PANEL_HANDOFF: 'AI Review Panel Handoff Clicked',

	// MESSAGES
	VIEWED_MESSAGES_PAGE: 'Messages Page Opened',
	VIEWED_REPLY_TEMPLATES_MODAL: 'Reply Templates Modal Opened',
	ACTION_MESSAGE_SENT: 'Message Sent',
	ACTION_CONVERSATION_OPENED: 'Conversation Opened',
	ACTION_MESSAGE_DELETED: 'Message Deleted',
	ACTION_MESSAGES_FILTER_APPLIED: 'Messages Filter Applied',

	// BULK ACTIONS
	CLICKED_BULK_ACTION: 'Bulk Action Clicked',
	CLICKED_BULK_REPLY: 'Bulk Reply Clicked',
	CLICKED_BULK_DELETE: 'Bulk Delete Clicked',
	CLICKED_BULK_EXPORT: 'Bulk Export Clicked',
	COMPLETED_BULK_ACTION: 'Bulk Action Completed',
	COMPLETED_BULK_REPLY: 'Bulk Reply Completed',
	COMPLETED_BULK_DELETE: 'Bulk Delete Completed',

	// PRICING / UPGRADE
	VIEWED_PRICING_PAGE: 'Pricing Page Opened',
	VIEWED_PRICING_ERROR_SHOWN: 'Pricing Error Shown',
	CLICKED_UPGRADE: 'Upgrade Clicked',
	CLICKED_SHOW_USAGE: 'Show Usage Clicked',
	CLICKED_PRICING_PAGE_UPGRADE: 'Pricing Page Upgrade Clicked',
	CLICKED_CONTACT_US: 'Contact Us Clicked',
	PAYMENT_VERIFIED: 'Payment Verified',

	// IMPORT FORM
	IMPORT_BUTTON_CLICKED: 'Import Button Clicked',
	IMPORT_TYPE_SELECTED: 'Import Type Selected',
	IMPORT_GOOGLE_FORM_URL_STEP_VIEWED: 'Import Google Form URL Step Viewed',
	IMPORT_GOOGLE_FORM_ONLY_SUCCESS: 'Import Google Form Only Success',
	VIEWED_IMPORT_FORM: 'Import Form Opened',
	ACTION_IMPORT_CSV_INVALID: 'Import CSV Invalid',
	ACTION_IMPORT_CSV_VALIDATION_ERRORS: 'Import CSV Validation Errors',
	ACTION_IMPORT_FAILED_PRE_PROCESSING: 'Import Failed Pre Processing',
	ACTION_IMPORT_FAILED_DURING_PROCESSING: 'Import Failed During Processing',
	ACTION_IMPORT_DRIVE_CONNECTION_FAILED: 'Import Drive Connection Failed',
	ACTION_IMPORT_DRIVE_PICKER_ERROR: 'Import Drive Picker Error',
	VIEWED_IMPORT_FORM_CSV_FILE_UPLOAD_AREA: 'Import Form CSV File Upload Step',
	VIEWED_IMPORT_FORM_CSV_FIELD_MAPPING: 'Import Form CSV Field Mapping Step',
	VIEWED_IMPORT_FORM_GOOGLE_DRIVE_AUTH_STEP: 'Import Form Google Drive Auth Step',
	VIEWED_IMPORT_FORM_PROCESSING_STEP: 'Import Form Processing Step',
	CLICKED_IMPORT_FORM_GOOGLE_DRIVE_SKIP: 'Import Form Google Drive Skip Clicked',
	ACTION_IMPORT_FORM_GOOGLE_DRIVE_AUTH_SUCCESS: 'Import Form Google Drive Auth Success',
	ACTION_IMPORT_FORM_GOOGLE_DRIVE_NO_FILES_SELECTED: 'Import Form Google Drive No Files Selected',
	COMPLETED_IMPORT_FORM: 'Import Form Success',

	// IMPORT SUBMISSIONS (import into existing form)
	IMPORT_CANDIDATES_BUTTON_CLICKED: 'Import Candidates Button Clicked',
	IMPORT_CANDIDATES_SCREEN_VIEWED: 'Import Candidates Screen Viewed',
	IMPORT_SUBMISSIONS_STARTED: 'Import Submissions Started',
	IMPORT_SUBMISSIONS_MAPPED: 'Import Submissions Mapped',
	IMPORT_SUBMISSIONS_PROCESSING: 'Import Submissions Processing',
	IMPORT_SUBMISSIONS_COMPLETED: 'Import Submissions Completed',

	// VIDEO
	ACTION_VIDEO_LOAD_FAILED: 'Video Load Failed',

	// VIDEO RECORDING
	CLICKED_VIDEO_START_RECORDING: 'Video Start Recording Clicked',
	CLICKED_VIDEO_RETAKE: 'Video Retake Clicked',
	CLICKED_VIDEO_TRY_AGAIN: 'Video Try Again Clicked',
	ACTION_VIDEO_START_RECORDING_SUCCESS: 'Video Start Recording Success',
	ACTION_VIDEO_PERMISSION_DENIED: 'Video Permission Denied',
	ACTION_VIDEO_PERMISSION_PREVIOUSLY_DENIED: 'Video Permission Previously Denied',
	ACTION_VIDEO_SAVING_STARTED: 'Video Saving Started',
	ACTION_VIDEO_SAVING_FAILED: 'Video Saving Failed',
	COMPLETED_VIDEO_SAVING: 'Video Saving Completed',
	CLICKED_VIDEO_DELETE: 'Video Delete Clicked',
	ACTION_VIDEO_CAMERA_CLOSED: 'Video Camera Closed',
	ACTION_VIDEO_DEVICE_SWITCHED: 'Video Device Switched',
	ACTION_VIDEO_NO_AUDIO_DETECTED: 'Video No Audio Detected',
	VIEWED_UNSAVED_VIDEO_WARNING: 'Unsaved Video Warning Shown',
	CLICKED_UNSAVED_VIDEO_GO_TO_VIDEO: 'Unsaved Video Go To Video Clicked',
	CLICKED_UNSAVED_VIDEO_SUBMIT_ANYWAY: 'Unsaved Video Submit Anyway Clicked',

	// SETTINGS
	VIEWED_SETTINGS_PAGE: 'Settings Page Opened',

	// WORKSPACE DEFAULTS
	VIEWED_DEFAULT_STAGES_MODAL: 'Default Stages Modal Opened',
	ACTION_DEFAULT_STAGE_ADDED: 'Default Stage Added',
	ACTION_DEFAULT_STAGE_DELETED: 'Default Stage Deleted',
	ACTION_DEFAULT_STAGE_UPDATED: 'Default Stage Updated',
	ACTION_DEFAULT_STAGES_REORDERED: 'Default Stages Reordered',
	VIEWED_DEFAULT_REPLY_SHORTCUTS_MODAL: 'Default Reply Shortcuts Modal Opened',
	ACTION_DEFAULT_REPLY_SHORTCUT_ADDED: 'Default Reply Shortcut Added',
	ACTION_DEFAULT_REPLY_SHORTCUT_DELETED: 'Default Reply Shortcut Deleted',
	ACTION_DEFAULT_REPLY_SHORTCUT_UPDATED: 'Default Reply Shortcut Updated',

	// APP LEVEL
	ACTION_VIEW_SWITCHED: 'View Switched',
	VIEWED_RATE_LIMIT_BANNER: 'Rate Limit Banner Viewed',
	VIEWED_API_ERROR_SHOWN: 'API error shown',

	// ANALYTICS
	VIEWED_ANALYTICS_PAGE: 'Analytics Page Opened',
	CLICKED_ANALYTICS_PAGE_VIEW_MORE: 'Analytics Page View More Clicked',

	// REFERRALS
	VIEWED_REFERRALS_PAGE: 'Referrals Page Opened',
	COMPLETED_REFERRALS_SETUP: 'Referrals Setup Completed',
	COMPLETED_CANDIDATE_REFERRED: 'Candidate Referred',
	COMPLETED_REFERRAL_SETTINGS_UPDATED: 'Referral Settings Updated',
	COMPLETED_REFERRER_ADDED: 'Referrer Added',
	COMPLETED_REFERRER_REMOVED: 'Referrer Removed',

	// ADD / EDIT CANDIDATE MODAL
	VIEWED_CANDIDATE_MODAL: 'Candidate Modal Opened',
	COMPLETED_CANDIDATE_MODAL_SUBMITTED: 'Candidate Modal Submitted',
	ACTION_CANDIDATE_MODAL_SUBMIT_FAILED: 'Candidate Modal Submit Failed',
	ACTION_CANDIDATE_FILE_UPLOADED: 'Candidate File Uploaded',
	ACTION_CANDIDATE_RESUME_AUTOFILL_STARTED: 'Candidate Resume Autofill Started',
	ACTION_CANDIDATE_RESUME_AUTOFILL_COMPLETED: 'Candidate Resume Autofill Completed',
	ACTION_CANDIDATE_RESUME_AUTOFILL_FAILED: 'Candidate Resume Autofill Failed',

	// AI AGENT
	VIEWED_AI_AGENT_PANEL: 'AI Agent Panel Opened',
	ACTION_AI_AGENT_PANEL_CLOSED: 'AI Agent Panel Closed',
	ACTION_AI_AGENT_MESSAGE_SENT: 'AI Agent Message Sent',
	ACTION_AI_AGENT_GENERATION_STOPPED: 'AI Agent Generation Stopped',
	ACTION_AI_AGENT_NEW_CHAT_STARTED: 'AI Agent New Chat Started',
	CLICKED_AI_AGENT_SUGGESTION_CHIP: 'AI Agent Suggestion Chip Clicked',
	CLICKED_AI_AGENT_ACTION_NUDGE: 'AI Agent Action Nudge Clicked',
	CLICKED_AI_AGENT_RESPONSE_LINK: 'AI Agent Response Link Clicked',
	VIEWED_AI_AGENT_CREDITS_EXHAUSTED: 'AI Agent Credits Exhausted Shown',
	VIEWED_AI_AGENT_ERROR: 'AI Agent Error Shown',
	CLICKED_AI_AGENT_FORM_PREVIEW_ACTION: 'AI Agent Form Preview Action Clicked',
	CLICKED_AI_AGENT_CAREERS_PREVIEW_ACTION: 'AI Agent Careers Preview Action Clicked',
	CLICKED_AI_AGENT_EMAIL_DRAFT_PREVIEW_ACTION: 'AI Agent Email Draft Preview Action Clicked',
	CLICKED_AI_AGENT_CANDIDATE_PREVIEW_ACTION: 'AI Agent Candidate Preview Action Clicked',
	ACTION_AI_AGENT_SKILL_CREATED: 'AI Agent Skill Created',
	ACTION_AI_AGENT_SKILL_DELETED: 'AI Agent Skill Deleted',
	ACTION_AI_AGENT_SKILL_TOGGLED: 'AI Agent Skill Toggled',
	ACTION_AI_AGENT_SKILL_INVOKED: 'AI Agent Skill Invoked',
	VIEWED_AI_AGENT_SKILLS_MENU: 'AI Agent Skills Menu Opened',
	ACTION_AI_AGENT_SKILL_SELECTED: 'AI Agent Skill Selected',

	// AI ONBOARDING
	ACTION_AI_ONBOARDING_STARTED: 'AI Onboarding Started',
	VIEWED_AI_ONBOARDING_OPENER: 'AI Onboarding Opener Shown',

	// FEEDBACK TEMPLATES
	ACTION_FEEDBACK_TEMPLATE_CREATED: 'Feedback Template Created',
	ACTION_FEEDBACK_TEMPLATE_DELETED: 'Feedback Template Deleted',
	ACTION_FEEDBACK_TEMPLATE_SET_AS_DEFAULT: 'Feedback Template Set As Default',
	VIEWED_MANAGE_FEEDBACK_TEMPLATES: 'Manage Feedback Templates Opened',
	ACTION_FEEDBACK_SUBMITTED_WITH_TEMPLATE: 'Feedback Submitted With Template',

	// ASSIGNMENTS — recruiter build funnel
	VIEWED_MANAGE_ASSIGNMENTS_MODAL: 'Manage Assignments Modal Opened',
	ACTION_ASSIGNMENT_CREATED: 'Assignment Created',
	ACTION_ASSIGNMENT_QUESTION_ADDED: 'Assignment Question Added',
	// churn, not a funnel step; discriminated by `edit_type`
	ACTION_ASSIGNMENT_QUESTION_EDITED: 'Assignment Question Edited',
	CLICKED_ASSIGNMENT_PREVIEW: 'Assignment Preview Opened',
	ACTION_ASSIGNMENT_DELETED: 'Assignment Deleted',

	// ASSIGNMENTS — recruiter send funnel
	VIEWED_SEND_ASSIGNMENT_MODAL: 'Send Assignment Modal Opened',
	CLICKED_SEND_ASSIGNMENT: 'Send Assignment Clicked',
	COMPLETED_SEND_ASSIGNMENT: 'Assignment Sent',
	ACTION_SEND_ASSIGNMENT_FAILED: 'Assignment Send Failed',
	CLICKED_SEND_ASSIGNMENT_RETRY: 'Send Assignment Retry Clicked',
	ACTION_ASSIGNMENT_LINK_DELETED: 'Assignment Link Deleted',

	// ASSIGNMENTS — candidate fill funnel
	VIEWED_ASSIGNMENT_PAGE: 'Assignment Page Opened',
	CLICKED_ASSIGNMENT_SUBMIT: 'Assignment Submit Clicked',
	COMPLETED_ASSIGNMENT_SUBMITTED: 'Assignment Submitted',
	ACTION_ASSIGNMENT_SUBMIT_VALIDATION_FAILED: 'Assignment Submit Validation Failed',
	ACTION_ASSIGNMENT_SUBMIT_FAILED: 'Assignment Submit Failed',
	ACTION_ASSIGNMENT_FILE_UPLOAD_FAILED: 'Assignment File Upload Failed',
	ACTION_ASSIGNMENT_LINK_EXPIRED: 'Assignment Link Session Expired',

	// MCP CONSENT — OAuth consent screen for connecting an MCP client (Claude, ChatGPT, Gemini)
	VIEWED_MCP_CONSENT_PAGE: 'MCP Consent Page Opened',
	VIEWED_MCP_CONSENT_INVALID_OR_EXPIRED: 'MCP Consent Invalid Or Expired Shown',
	VIEWED_MCP_CONSENT_NO_WORKSPACE: 'MCP Consent No Workspace Shown',
	CLICKED_MCP_CONSENT_ALLOW: 'MCP Consent Allow Clicked',
	CLICKED_MCP_CONSENT_DENY: 'MCP Consent Deny Clicked',
	ACTION_MCP_CONSENT_APPROVED: 'MCP Consent Approved',
	ACTION_MCP_CONSENT_DENIED: 'MCP Consent Denied',
	ACTION_MCP_CONSENT_APPROVE_FAILED: 'MCP Consent Approve Failed',
	ACTION_MCP_CONSENT_DENY_FAILED: 'MCP Consent Deny Failed',

	// OFFER LETTERS — member template funnel
	VIEWED_MANAGE_OFFER_TEMPLATES_MODAL: 'Manage Offer Templates Modal Opened',
	ACTION_OFFER_TEMPLATE_CREATED: 'Offer Template Created',
	ACTION_OFFER_TEMPLATE_DELETED: 'Offer Template Deleted',
	VIEWED_OFFER_TEMPLATE_EDITOR: 'Offer Template Editor Opened',
	ACTION_OFFER_TEMPLATE_EDITOR_FAILED: 'Offer Template Editor Open Failed',

	// OFFER LETTERS — member send funnel
	VIEWED_SEND_OFFER_MODAL: 'Send Offer Modal Opened',
	CLICKED_SEND_OFFER: 'Send Offer Clicked',
	CLICKED_PREVIEW_OFFER: 'Offer Preview Clicked',
	COMPLETED_SEND_OFFER: 'Offer Sent',
	ACTION_SEND_OFFER_FAILED: 'Offer Send Failed',
	COMPLETED_OFFER_MESSAGE_SENT: 'Offer Message Sent',
	CLICKED_SKIP_OFFER_MESSAGE: 'Offer Message Skipped',
	ACTION_OFFER_RESCINDED: 'Offer Rescinded',
	CLICKED_OFFER_CARD_ACTION: 'Offer Card Action Clicked',

	// OFFER LETTERS — candidate page
	VIEWED_OFFER_PAGE: 'Offer Page Opened',
	CLICKED_DOWNLOAD_SIGNED_OFFER: 'Signed Offer Download Clicked',
};
